// The `#t=emb_...` fragment is stripped right after load, so a reload used to
// arrive with no token and show "link unavailable" mid-setup. The token is kept
// in the tab's sessionStorage keyed by the exact path it was issued for: a
// reload of that page recovers it, while another tab, another page or the OAuth
// popup (a different path) never picks it up. The server still enforces expiry.

type TokenStore = Pick<Storage, "getItem" | "setItem">;

const TOKEN_RE = /^emb_[A-Za-z0-9_-]+$/;

export const linkTokenKey = (path: string): string => `fastn.linkToken:${path}`;

export function resolveLinkToken(path: string, hash: string, store: TokenStore | null): string | null {
  const fromHash = hash.match(/[#&]t=(emb_[A-Za-z0-9_-]+)/)?.[1] ?? null;
  if (!store) return fromHash;
  try {
    if (fromHash) {
      store.setItem(linkTokenKey(path), fromHash);
      return fromHash;
    }
    const kept = store.getItem(linkTokenKey(path));
    return kept && TOKEN_RE.test(kept) ? kept : null;
  } catch {
    return fromHash;
  }
}
